// app/javascript/controllers/chat_sidebar_controller.js (updated)
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["search", "chatList", "chatItem"]

  connect() {
    // Store original chat items for search functionality
    this.originalChatItems = []
    if (this.hasChatItemTarget) {
      this.chatItemTargets.forEach(item => {
        this.originalChatItems.push({
          element: item,
          text: item.textContent.toLowerCase()
        })
      })
    }

    console.log('checking roomid')
    const roomId = this.element.dataset.roomId
    if (roomId) {
      const currentItem = this.chatItemTargets.find((item)=> item.dataset.roomId == roomId)
      if (currentItem) {
        currentItem.classList.add("active")
        currentItem.click()
      }
    }
  }

  search(event) {
    const searchTerm = event.target.value.toLowerCase().trim()

    if (!this.hasChatItemTarget) return

    if (searchTerm === '') {
      // Show all items
      this.chatItemTargets.forEach(item => {
        item.classList.remove('hidden')
      })
      return
    }

    // Filter chat items
    this.originalChatItems.forEach(itemData => {
      const matches = itemData.text.includes(searchTerm)
      itemData.element.classList.toggle('hidden', !matches)
    })
  }

  // Handle selecting a chat room
  selectRoom(event) {
    // Remove active class from all rooms
    this.chatItemTargets.forEach(item => {
      item.classList.remove('active')
    })

    // Add active class to selected room
    event.currentTarget.classList.add('active')
  }

  // Update unread message badges
  updateUnreadCount(event) {
    const { roomId, count } = event.detail
    const badge = this.element.querySelector(`[data-room-id="${roomId}"] [data-unread-badge]`)

    if (badge) {
      badge.textContent = count
      badge.classList.toggle('hidden', count === 0)
    }
  }

  // Open new chat modal
  openNewChatModal() {
    const modal = document.querySelector('[data-controller="chat-new-room"]')
    if (modal) { modal.showModal() }
  }

  // Refresh the sidebar with new data
  refresh() {
    // This could be called when new messages arrive or rooms are added
    fetch('/chat/rooms', {
      headers: {
        'Accept': 'text/vnd.turbo-stream.html'
      }
    })
      .then(response => response.text())
      .then(html => {
        // Update sidebar content
        if (this.element) {
          this.element.innerHTML = html
        }
      })
  }
}
